<template>
  <b-row>
    <b-col cols="12">
      <b-overlay :show="isLoading" rounded="sm">
        <b-card no-body class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
          <!-- <h6 class="mb-0 text-left">Manage Emloyees</h6> -->
          <b-navbar class="background-white" toggleable="lg">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-navbar-brand href="#">
              <strong style="color: #3b3e66">Archived Employee</strong>
            </b-navbar-brand>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    variant="outline-info"
                    size="sm"
                    class="mr-2"
                    @click="reloadTable"
                  >
                    <!-- <font-awesome-icon icon="sync" /> -->
                    Reload
                  </b-button>
                  <b-form onSubmit="return false;">
                    <b-input-group size="sm">
                      <b-form-input
                          type="search"
                          @input="onEmpltyFilter($event)"
                          v-model="filter"
                          @keyup.enter="submitSearch"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!filter"
                            variant="outline-success"
                            @click="submitSearch"
                          >Search</b-button>
                        <b-button
                            :disabled="!filter"
                            @click="setFIlterClear"
                          >Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form>
                </b-nav-form>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <b-table
            class="main-table"
            hover
            striped
            sticky-header="calc(100vh - 295px)"
            ref="table"
            id="terminated-employee-table"
            :busy.sync="isLoading"
            :fields="staticFields"
            :items="getEmployeeTableData"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filterTable ? filter : null"
            selectable
            select-mode="single"
            @row-selected="onSelectRow"
            no-sort-reset
          >
            <template v-slot:cell(first_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.first_name }}
                </p>
              </template>
            <template v-slot:cell(last_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.last_name }}
                </p>
              </template>
            <template v-slot:cell(status)="data">
              <b-badge v-if="data.item.status == '1'" variant="success"
                >Active</b-badge
              >
              <b-badge v-if="data.item.status == '2'" variant="warning"
                >Passive</b-badge
              >
              <b-badge v-if="data.item.status == '3'" variant="danger"
                >Archived</b-badge
              >
            </template>
            <template v-slot:cell(is_senior_management)="data">
              <b-badge
                v-if="data.item.is_senior_management == '1'"
                variant="success"
                >Yes</b-badge
              >
              <b-badge
                v-if="data.item.is_senior_management == '0'"
                variant="dark"
                >No</b-badge
              >
            </template>
            <template v-slot:cell(is_c_suite_officer)="data">
              <b-badge
                v-if="data.item.is_c_suite_officer == '1'"
                variant="success"
                >Yes</b-badge
              >
              <b-badge v-if="data.item.is_c_suite_officer == '0'" variant="dark"
                >No</b-badge
              >
            </template>
          </b-table>
          <template v-slot:footer>
            <b-row>
              <b-col cols="2">
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col cols="6">
                <p class="text-center">
                  Showing Result From
                  <b>{{ fromRows }}</b> to
                  <b>{{ toRows }}</b>
                </p>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  class="float-right"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  aria-controls="terminated-employee-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>
<script>
import moment from "moment";
import "moment/locale/es";
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "terminatedEmployee",
  components: {},
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      filter: "",
      perPage: 10,
      currentPage: 1,
      fromRows: 0,
      toRows: 0,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        // { key: "created_at", label: "Age", sortable: true },
        { key: "first_name", label: "First Name", sortable: false },
        { key: "last_name", label: "Last Name", sortable: false },

        { key: "department", label: "Division/Business Unit", sortable: true },
        // { key: "email", label: "Email", sortable: false },
        { key: "country_name", label: "Country", sortable: true },
        { key: "status", label: "Status", sortable: true },
        // {
        //   key: "is_senior_management",
        //   label: "Is Senior Manager",
        //   sortable: true,
        // },
        // { key: "is_c_suite_officer", label: "Is C Suite", sortable: true },
        // { key: "actions", label: "Actions", sortable: false },
      ],
      showRenewForm: false,
      processing: false,
      counter: 1,
      interval: null,
      employeeId: null,
      firstName: null,
      lastName: null,
      filterTable: false,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "terminated-employee-table");
    },
    submitSearch () {
      if ( this.filter ) {
        this.filterTable = true;
      }
    },
    onEmpltyFilter ( value ) {
      if ( value ) {
        return;
      } else {
        this.setFIlterClear();
      }
    },
    OpenProfilePage ( url ) {
      this.$router.push( url );
    },
    onSelectRow ( data ) {
      if ( data[0].id ) {
        this.$router.push( "/employee-profile/" + data[0].id );
      }
    },
    setFIlterClear () {
      this.filter = "";
      this.filterTable = false;
      this.reloadTable();
    },
    async getEmployeeTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let response = await HTTP(
        "post",
        "api/v1/employees/terminated/data",
        formData
      );
      try {
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.$store.state.terminatedEmployeeTabLazyLoad = false;
        this.isLoading = false;
        this.filterTable = false;
        return response.data.data;
      } catch (err) {
        this.isLoading = false;
        return [err];
      } finally {
        this.isLoading = false;
      }
    },
    // OpenDetailPage(url) {
    //   this.$router.push(url);
    // },
  },
};
</script>